import compose from 'lodash/flowRight'
import { connect } from 'react-redux'

import { isAccountTypeBrand } from 'store/currentUser/selectors'

import ExcelSummaryModal from './ExcelSummaryModal.component'

const mapStateToProps = (state) => ({
  importedFiles: state.excelOrdersModal.importedFiles,
  isBrandAccount: isAccountTypeBrand(state),
})

const withRedux = connect(mapStateToProps)
export default compose(withRedux)(ExcelSummaryModal)
